import { computationSystemPerformanceAPI } from "./computation";
var defaultAPI = computationSystemPerformanceAPI;
export default defaultAPI;
